<template>
  <StoryblokComponent v-for="blokBody in blok.blocks" :key="blokBody._uid" :blok="blokBody" />
  <Container no-padding-top>
    <div :class="$style['grid']">
      <Card
        v-for="event in blok.events"
        :key="event.id"
        reveal
        :title="event.name"
        target="_blank"
        :to="event.content.url.cached_url"
        :alt="event.content.image?.alt"
        :image="event.content.image?.filename">
        <template #actions>
          <Button
            icon="ExternalLink"
            color="opacity"
            icon-pos="right">
            Bestel kaarten
          </Button>
        </template>
      </Card>
    </div>
  </Container>
</template>
<script setup>
const { formatEvent, formatBreadcrumbs } = useHrMeta()
const props = defineProps({ blok: Object })
formatEvent({ title: props.blok?.title, description: props.blok?.description, events: props.blok?.events })
formatBreadcrumbs()
</script>
<style module>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
  gap: var(--spacing-l);
}
</style>
